import { offlineDb } from "@/features/mobile/offline/db";
import { createDayStore, type CachedDay, type DayStore } from "@shared/mobil/offline/dayStore";
import type { OrderReferenceSnapshot } from "@/features/orders/orderReference";
import type { DayTexts } from "@/lib/api/translations";

/**
 * Die Bindung des Tagesspeichers an diese Anwendung — der Speicher selbst steht
 * seit M1.2 in `@shared/mobil/offline/dayStore`.
 *
 * Hier werden die beiden durchgereichten Typen gesetzt: `OrderReferenceSnapshot`
 * für die Stammdaten und `DayTexts` für das Wörterbuch. Der Speicher kennt
 * beide nicht und muss es nicht — er legt sie ab und gibt sie zurück.
 *
 * **`dayStore` bleibt an diesem Pfad.** Die Ansichten importieren weiter von
 * hier, nicht aus `shared/`: ihre Tests mocken genau diesen Pfad
 * (AGENTS.md, jsdom-Abschnitt), und ein Import am Mock vorbei liefe still gegen
 * das echte Modul.
 */
export type { CachedDay, DayStore };

export const dayStore: DayStore<OrderReferenceSnapshot, DayTexts> = createDayStore(offlineDb());
